module.exports = {
  "country": "FR",
  "artist": "Isabelle Aubret",
  "song": "Un Premier Amour",
  "year": "1962",
  "place": "1",
  "spotify": "10rVfYzeVTS28RHQKNROd4"
};